import App from '../../../vendor_core/core/src/App';
import { Tween } from '../../../vendor_core/core/src/Tween';
import GameModel from '../../../vendor_core/core/src/model/GameModel';
import UIController from '../../../vendor_core/core/src/ui/UIController';
import { UIStates } from '../../../vendor_core/core/src/ui/UIStates';
import { DefaultLayers } from '../../../vendor_core/core/src/utils/Layers';
import ViewManager from '../../../vendor_core/core/src/utils/ViewManager';
import ReelGroup from '../../../vendor_core/core/src/views/ReelGroup';
import VendorSpinResultState from "../../../vendor_core/src/states/VendorSpinResultState"
import Configs from '../../../vendor_core/src/vendorConfigs/Configs';

export default class MSSpinResultState extends VendorSpinResultState {
    // Set Stop Spin Btn only when min spin time is passed
    protected setUIStateOnReelStop(): void {
        const reelGroup = <ReelGroup>ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene().getSubView("ReelGroup");
        if (reelGroup.getSpinTimePassed() >= (App.config.minSpinTime * 1000)) {
            UIController.setState(UIStates.SPIN_RESULT);
        } else {
            if (Configs.reels?.clientMinSpinTime && (App.config.minSpinTime * 1000) < Configs.reels.clientMinSpinTime && !GameModel.turboSpin) {
                const delay = (App.config.minSpinTime * 1000) - reelGroup.getSpinTimePassed()
                Tween.delayedCall((delay / 1000), () => {
                    UIController.setState(UIStates.SPIN_RESULT);
                })
            }
        }
    }
    // This is client specific logic !!!
    private getStopReelsDelayTime(reelGroup: ReelGroup): number {
        const result = Math.max((Configs.reels?.clientMinSpinTime || 0), (App.config.minSpinTime * 1000)) - reelGroup.getSpinTimePassed() - reelGroup.getSpinStopTime();
        return (Math.floor(result) / 1000)
    }

    protected stopReels(): void {
        if (App.config.minSpinTime < (Configs.reels?.clientMinSpinTime || 0)) {
            const reelGroup = <ReelGroup>ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene().getSubView("ReelGroup");
            if (reelGroup.getSpinTimePassed() >= (Configs.reels.clientMinSpinTime - (App.config.stopTime * 1000)) || GameModel.turboSpin) {
                if (GameModel.turboSpin) {
                    let delay = (App.config.minSpinTime * 1000) - reelGroup.getSpinTimePassed() - reelGroup.getSpinStopTime();
                    if (delay < 0) {
                        // Delay for security for passing min spin time  (because is possible calculation for spin pass time have correction of +- 20-40 ms )
                        delay = 100;
                    } else {
                        // Convert to seconds
                        delay /= 1000;
                    }
                    super.stopReels(delay / 1000)
                } else {
                    super.stopReels()
                }
            } else {
                super.stopReels(this.getStopReelsDelayTime(reelGroup))
            }
        } else {
            super.stopReels()
        }
    }
}
